// Some browser ICU builds lack Central Asian locales and silently use en-US.
// Preserve their technical decimal/grouping convention without SSR/client drift.
export function technicalNumberFormatter(locale: string, options: Intl.NumberFormatOptions = {}) {
  const language = locale.toLowerCase().split("-")[0];
  const group = language === "en" ? "," : language === "tr" ? "." : "\u00a0";
  const decimal = language === "en" ? "." : ",";
  const formatter = new Intl.NumberFormat("en-US", options);
  return {
    format(value: number) {
      return formatter.formatToParts(value).map(part => part.type === "group" ? group : part.type === "decimal" ? decimal : part.value).join("");
    },
  };
}
